"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYNC_STRATEGIES = exports.ProjectSerializedOut = exports.ProjectSerializedIn = exports.FOREIGN_TYPES = exports.TAX_EXEMPTION_STATUSES = exports.SHIPPING_TYPES = exports.SAMPLE_TYPES = exports.INFO_SOURCES = exports.FULFILLMENT_METHODS = exports.ProjectConfigurationSerialized = exports.ProjectConfiguration = exports.ProjectItem = exports.Product = exports.Design = exports.SizeQuantity = exports.CoreOrderData = exports.ItemFulfillment = exports.TURN_TIMES = exports.DistributedOrderData = exports.Project = exports.ProjectKey = void 0;
// DynamoDB hash key
class ProjectKey {
    constructor() {
        this.id = '';
        this.version = 0;
    }
}
exports.ProjectKey = ProjectKey;
// All other DynamoDB fields
class Project extends ProjectKey {
}
exports.Project = Project;
class DistributedOrderData {
}
exports.DistributedOrderData = DistributedOrderData;
exports.TURN_TIMES = {
    STANDARD: 'STANDARD',
    QUICKER: 'QUICKER',
    RUSH: 'RUSH',
    SUPERRUSH: 'SUPERRUSH', // Typically 3 days with surcharge
};
class ItemFulfillment {
}
exports.ItemFulfillment = ItemFulfillment;
class CoreOrderData {
}
exports.CoreOrderData = CoreOrderData;
class SizeQuantity {
}
exports.SizeQuantity = SizeQuantity;
class Design {
}
exports.Design = Design;
class Product {
}
exports.Product = Product;
class ProjectItem {
}
exports.ProjectItem = ProjectItem;
class ProjectConfiguration {
}
exports.ProjectConfiguration = ProjectConfiguration;
class ProjectConfigurationSerialized {
}
exports.ProjectConfigurationSerialized = ProjectConfigurationSerialized;
exports.FULFILLMENT_METHODS = {
    BULK: 'BULK',
    BSS: 'BSS',
    FUNDRAISER: 'FUNDRAISER',
    GROUPS: 'GROUPS',
    STORES: 'STORES', // Online store handled by stores
};
exports.INFO_SOURCES = {
    COMMUNITY: 'COMMUNITY',
    ORGANIZER: 'ORGANIZER', // All info will be provided directly by the organizer
};
exports.SAMPLE_TYPES = {
    PLA_BLANKS_SAMPLE: 'pla_blanks_sample',
    PLA_PRINTED_SAMPLE: 'pla_printed_sample',
};
exports.SHIPPING_TYPES = {
    BULK: 'BULK',
    INDIVIDUAL: 'INDIVIDUAL', // Order will be split into multiple shipments
};
exports.TAX_EXEMPTION_STATUSES = {
    NON_EXEMPT: 'NON_EXEMPT',
    CLAIMED: 'CLAIMED',
    EXEMPT: 'EXEMPT', // The user has been verified as tax exempt.
};
exports.FOREIGN_TYPES = {
    CORE_ORDER: 'CORE_ORDER',
    GROUP_ORDER: 'GROUP_ORDER',
};
class ProjectSerializedIn {
}
exports.ProjectSerializedIn = ProjectSerializedIn;
class ProjectSerializedOut extends ProjectSerializedIn {
}
exports.ProjectSerializedOut = ProjectSerializedOut;
exports.SYNC_STRATEGIES = {
    DESIGN: 'DESIGN',
    CORE_ORDER: 'CORE_ORDER',
};
